import styled from 'styled-components'
import { IGridContainer } from './types'

export const GridContainer = styled.div<IGridContainer>`
  height: ${({ height }) => height || '300px'};
  margin: ${({ margin }) => margin || '0'};
  width: 100%;
`
